<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2e"><a id="page_15"></a><a id="frontmatter4"></a>The Destinations</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter4.vue?f1ef2a80